<app-modal title="Fichier SAP" size="md" closeLabel="Fermer" (closed)="fermer()">
  <form [formGroup]="fichierSapForm" class="fichier-sap-form">
    <p class="fichier-sap-form__aide">Sélectionnez la période à exporter.</p>
    <app-plage-dates
      [startDate]="fichierSapForm.controls.filtreDateDebut"
      [endDate]="fichierSapForm.controls.filtreDateFin"
    ></app-plage-dates>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="fermer()">Annuler</button>
    <button
      type="button"
      appButton
      variant="primary"
      (click)="
        telechargerFichier(fichierSapForm.controls.filtreDateDebut.value, fichierSapForm.controls.filtreDateFin.value)
      "
    >
      Télécharger
    </button>
  </div>
</app-modal>
